// @flow
import { MONTH_CHANGE_SEASON, LAST_DAY_BEFORE_CHANGE_SEASON } from 'constants/documentsConstants';
import type { DocumentType } from 'types/PageDetail';

export function sortDocumentsByName(documents: Array<DocumentType>): Array<DocumentType> {
  return documents.sort((a, b) => {
    return a.title < b.title ? -1 : a.title > b.title ? 1 : 0;
  });
}

export function sortDocumentsByDate(documents: Array<DocumentType>): Array<DocumentType> {
  return documents.sort((a, b) => {
    return a.date < b.date ? 1 : a.date > b.date ? -1 : 0;
  });
}

export function sortDocumentByMonth(
  documents: Array<DocumentType>,
  from: Date,
  to: Date,
  documentDisplayedNumber: number
): Array<{
  year: number,
  month: number,
  documents: Array<DocumentType>
}> {
  let documentsToDisplay = documentDisplayedNumber;
  return documents
    .sort((a, b) => {
      return a.date < b.date ? 1 : a.date > b.date ? -1 : 0;
    })
    .reduce((accumulator, currentValue) => {
      const currentValueDate = new Date(currentValue.date);
      if (currentValueDate >= from && currentValueDate <= to && documentsToDisplay > 0) {
        documentsToDisplay--;
        const entryWithSameMonth = accumulator.find(element => element.month === currentValueDate.getMonth());
        if (entryWithSameMonth) {
          return [
            ...accumulator.filter(entry => entry.month !== currentValueDate.getMonth()),
            {
              year: currentValueDate.getFullYear(),
              month: entryWithSameMonth.month,
              documents: [...entryWithSameMonth.documents, currentValue]
            }
          ];
        } else
          return [
            ...accumulator,
            { year: currentValueDate.getFullYear(), month: currentValueDate.getMonth(), documents: [currentValue] }
          ];
      } else return accumulator;
    }, []);
}

export function getSeasonFromDocuments(
  documents: Array<DocumentType>
): Array<{ value: { from: Date, to: Date }, label: string }> {
  return documents.reduce((accumulator, currentValue) => {
    const currentValueDate = new Date(currentValue.date);
    const year = currentValueDate.getFullYear();
    const month = currentValueDate.getMonth();

    const label = month < MONTH_CHANGE_SEASON ? `Saison ${year - 1}/${year}` : `Saison ${year}/${year + 1}`;
    const from =
      month < MONTH_CHANGE_SEASON ? new Date(year - 1, MONTH_CHANGE_SEASON, 1) : new Date(year, MONTH_CHANGE_SEASON, 1);
    const to =
      month < MONTH_CHANGE_SEASON
        ? new Date(year, MONTH_CHANGE_SEASON - 1, LAST_DAY_BEFORE_CHANGE_SEASON)
        : new Date(year + 1, MONTH_CHANGE_SEASON - 1, LAST_DAY_BEFORE_CHANGE_SEASON);

    if (accumulator.find(entry => entry.label === label)) return accumulator;
    else return [...accumulator, { value: { from, to }, label }];
  }, []);
}

export function getTypesFromDocuments(documents: Array<DocumentType>): Array<{ value: string, label: string }> {
  return documents.reduce((accumulator, currentValue) => {
    const label = currentValue.tags;

    if (accumulator.find(entry => entry.label === label)) return accumulator;
    else return [...accumulator, { value: label, label }];
  }, []);
}
